module.exports = __webpack_public_path__ + "img/GBM1_Neutrophils.807dbb61.png";